import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import {AppCTX} from '../data/AppContext';
import SearchPlaces from './SearchPlaces';

export default function SearchAppBar() {
  const {map, user} = React.useContext(AppCTX);

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
        >
          {user?.data?.teamName}
        </Typography>
        <Box
          sx={{ flexGrow: 1, display: { xs: 'flex', sm: 'block' }, paddingLeft:{xs:'20px'}}}
        >
          {map != null && <SearchPlaces gmap={map}/>}
        </Box>
      </Toolbar>
    </AppBar>
  );
}